import {
  $BODY,
  $WINDOW,
  BODY_LOCK_CLASS,
  L_MOBILE_WIDTH,
  SHOW_CLASS,
} from "../lib/constants";
import { swipeFunction } from "../lib/utils";

const openProductsDescriptionModal = () => {
  const $openBtns = $(".js-card-btn-product");

  $.each($openBtns, function (_, el) {
    const $openBtn = $(el);

    const $card = $openBtn.parent();
    const $cardModal = $card.find(".js-card-modal");
    const $closeBtn = $card.find(".js-btn-close");

    $openBtn.on("click", function () {
      $BODY.addClass(BODY_LOCK_CLASS);
      $cardModal.addClass(SHOW_CLASS);
    });

    $closeBtn.on("click", function () {
      $BODY.removeClass(BODY_LOCK_CLASS);
      $cardModal.removeClass(SHOW_CLASS);
    });

    $cardModal.on("click", ({ target }) => {
      if ($(target).hasClass("js-card-modal")) {
        $cardModal.removeClass(SHOW_CLASS);
        $BODY.removeClass(BODY_LOCK_CLASS);
      }
    });

    if ($WINDOW.width() <= L_MOBILE_WIDTH) {
      swipeFunction(document.querySelectorAll(".js-card-modal"), () => {
        $cardModal.removeClass(SHOW_CLASS);
        $BODY.removeClass(BODY_LOCK_CLASS);
      });
    }
  });
};

export const productCardFunctions = () => {
  openProductsDescriptionModal();
};
